import { useEffect, useState } from 'react';
import { LDMultiKindContext } from 'launchdarkly-js-client-sdk';

import { useSecureFeatureFlagContext } from '@/hooks/featureFlag/useSecureFeatureFlagContext';
import { type SecureFeatureFlagContext } from '@/types/featureFlagContext';

export function useSetFeatureFlagProviderContext() {
  const [isSendingContext, setIsSendingContext] = useState(false);
  const [multiContext, setMultiContext] = useState<LDMultiKindContext | null>(null);
  const [hash, setHash] = useState<string | null>(null);

  const {
    isLoading: isContextKeyLoading,
    contextKey,
  } = useSecureFeatureFlagContext();

  useEffect(() => {
    if (!contextKey) return;
    setIsSendingContext(true);

    const payload = contextKey;
    const context = convertApiResponseToLDMultiContext(payload);

    setMultiContext(context);
    const secureHash = getHashFromPayload(payload);
    setHash(secureHash ?? null);
    setIsSendingContext(false);

  }, [contextKey]);

  const isLoading = isContextKeyLoading || isSendingContext;

  return { isLoading, isSendingContext, multiContext, hash };
}

const convertApiResponseToLDMultiContext = (payload: SecureFeatureFlagContext) => {
  const multiContext: LDMultiKindContext = { kind: 'multi' };

  const attributes = getAttributesFromPayload(payload);

  const items = attributes.contexts ?? [];

  for (const item of items) {
    const { kind, ...rest } = item;

    if (!kind || typeof rest.key !== 'string' || !rest.key) {
      continue;
    }

    multiContext[kind] = { ...(rest) };
  }

  return multiContext;
};

const getAttributesFromPayload = (payload: SecureFeatureFlagContext) => {
  return payload.attributes || payload;
};

const getHashFromPayload = (payload: SecureFeatureFlagContext) => {
  const attributes = getAttributesFromPayload(payload);
  return attributes.secureModeHash;
};
